// import {Configurator, DashboardNavbar, Footer, Sidenav,} from "@/widgets/layout";
import {StatisticsCard} from './widgets/statistics-card'
import {BsBank, BsBank2, BsCashStack, BsWallet2} from "react-icons/bs";
import {Card, CardBody, CardHeader, Typography} from "@material-tailwind/react";
import React from "react";
import persianNumberFormat from "../../helper/PersianNumberFormat";

export function AdminFinance({finance}) {

  const compare_text = (new_count, pre_count, title) => {
    const count_difference = new_count - pre_count;
    if (count_difference === 0) {
      return 'مشابه ماه گذشته'
    } else if (count_difference > 0) {
      return persianNumberFormat(`${count_difference} ${title} بیشتر از ماه گذشته`, true)
    } else if (count_difference < 0) {
      return persianNumberFormat(`${Math.abs(count_difference)} ${title} کمتر از ماه گذشته`, true)
    }
  }

  const compare_text_day = (new_count, pre_count, title) => {
    const count_difference = new_count - pre_count;
    if (count_difference === 0) {
      return 'مشابه روز گذشته'
    } else if (count_difference > 0) {
      return persianNumberFormat(`${count_difference} ${title} بیشتر از روز گذشته`, true)
    } else if (count_difference < 0) {
      return persianNumberFormat(`${Math.abs(count_difference)} ${title} کمتر از روز گذشته`, true)
    }
  }

  const compare_text_week = (new_count, pre_count, title) => {
    const count_difference = new_count - pre_count;
    if (count_difference === 0) {
      return 'مشابه هفته گذشته'
    } else if (count_difference > 0) {
      return persianNumberFormat(`${count_difference} ${title} بیشتر از هفته گذشته`, true)
    } else if (count_difference < 0) {
      return persianNumberFormat(`${Math.abs(count_difference)} ${title} کمتر از هفته گذشته`, true)
    }
  }

  return (
    <div className="w-full mb-8">
      <Card className="pt-8 w-full bg-gray-200">
        <CardHeader floated={true} shadow={false} className="bg-gray-200">
          <div className="mb-8 flex flex-col items-start justify-between md:flex-row">
            <Typography variant="h5" color="blue-gray">خلاصه مالی</Typography>
          </div>

        </CardHeader>
        <CardBody className="overflow-x-auto w-full">

          <div
            className="grid grid-cols-1 gap-8 mb-8 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 xxl:grid-cols-6">
            <StatisticsCard color="gray" title="واریز درگاه" value={finance.today_deposit}
                            footer={compare_text_day(finance.today_deposit, finance.pre_today_deposit, 'ریال')}
                            icon={<BsWallet2 className="text-center" size={40}/>}/>
            <StatisticsCard color="gray" title="شارژ توسط ادمین" value={finance.today_increase_wallet}
                            footer={compare_text_day(finance.today_increase_wallet, finance.pre_today_increase_wallet, 'ریال')}
                            icon={<BsCashStack className="text-center" size={40}/>}/>
            <StatisticsCard color="gray" title="درآمد هفته" value={finance.last_week_income}
                            footer={compare_text_week(finance.last_week_income, finance.pre_week_income, 'ریال')}
                            icon={<BsBank className="text-center" size={40}/>}/>
            <StatisticsCard color="gray" title="درآمد ماه" value={finance.last_month_income}
                            footer={compare_text(finance.last_month_income, finance.pre_month_income, 'ریال')}
                            icon={<BsBank2 className="text-center" size={40}/>}/>
          </div>


        </CardBody>
      </Card>
    </div>
  );

}

export default AdminFinance;
